import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import { IOWidget, mk_widget, option, Options, Widget } from "../widget";
import { ButtonOptions } from "./button";

/** @deprecated Use [[wrapHTML]] instead. */
export const a = function <a>(label: string, options?: ButtonOptions): IOWidget<() => a, a> {
  return (input: () => a) =>
    mk_widget({
      run: (on_done: (output: a) => void) =>
        <a  {...(option("extraProperties", options) || {})}
          id={option("id", options)}
          className={option("className", options)}
          role={option("role", options)}
          key={options ? options.key : undefined}
          onClick={e => {
            if (option("disabled", options)) return
            on_done(input())
            e.preventDefault()
          }} href="#">
          {label}
        </a>
    })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const aWrapper = function <a>(inner_widget: Widget<{}>, options?: ButtonOptions): IOWidget<() => a, a> {
  return (input: () => a) =>
    mk_widget({
      run: (on_done: (output: a) => void) =>
        <a {...option("extraProperties", options)}
          id={option("id", options)}
          className={option("className", options)}
          key={options ? options.key : undefined}
          onClick={e => {
            if (option("disabled", options)) return
            on_done(input())
            e.preventDefault()
          }} href="#">
          {
            inner_widget.run(_ => { })
          }
        </a>
    })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const link = function (label: string, href: string, options?: Options & { target?: "_blank" }): Widget<{}> {
  return mk_widget({
    run: (on_done: (output: {}) => void) =>
      href.startsWith('http') || option("target", options) == '_blank' ? (
        <a {...option("extraProperties", options)}
          id={option("id", options)}
          role={option("role", options)}
          className={option("className", options)}
          key={options ? options.key : undefined}
          href={href}
          target={option("target", options)}>
          {label}
        </a>
      ) : (
          <Link  {...option("extraProperties", options)}
            id={option("id", options)}
            role={option("role", options)}
            className={option("className", options)}
            key={options ? options.key : undefined}
            to={href}
            target={option("target", options)}>
            {label}
          </Link>
        )
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const linkWrapper = function <a>(inner_widget: Widget<a>, href: string, options?: Options & { target?: "_blank" }): Widget<a> {
  return mk_widget({
    run: (on_done: (output: a) => void) =>
      href.startsWith('http') || option("target", options) == '_blank' ? (
        <a {...option("extraProperties", options)}
          id={option("id", options)}
          role={option("role", options)}
          className={option("className", options)}
          key={options ? options.key : undefined}
          href={href}
          target={option("target", options)}>
          {inner_widget.run(on_done)}
        </a>
      ) : (
          <Link {...option("extraProperties", options)}
            id={option("id", options)}
            role={option("role", options)}
            className={option("className", options)}
            key={options ? options.key : undefined}
            to={href}
            target={option("target", options)}>
            {inner_widget.run(on_done)}
          </Link>
        )
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const navLink = function (label: string | Widget<never>, to: string, options?: Options): Widget<{}> {
  return mk_widget({
    run: (on_done: (output: {}) => void) =>
      <NavLink
        {...option("extraProperties", options)}
        id={option("id", options)}
        className={option("className", options)}
        role={option("role", options)}
        key={options ? options.key : undefined}
        to={to} >
        {
          typeof (label) == "string" ? label
            : label.run(_ => { })
        }
      </NavLink>
  })
}
